import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function Forms(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
      fill={color || "#bbb"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M16.7643 9.25C16.4524 9.23064 16.1606 9.08881 15.9516 8.85503C15.7425 8.62125 15.633 8.31422 15.6467 8V3.475C15.6603 3.16078 15.5508 2.85374 15.3418 2.61997C15.1327 2.38619 14.8409 2.24436 14.529 2.225H3.26736C2.9555 2.24436 2.66365 2.38619 2.45463 2.61997C2.24561 2.85374 2.13613 3.16078 2.14974 3.475V16.25C2.13613 16.5642 2.24561 16.8713 2.45463 17.105C2.66365 17.3388 2.9555 17.4806 3.26736 17.5H7.94747C8.25416 17.5327 8.53797 17.6785 8.74424 17.9093C8.9505 18.1401 9.06463 18.4396 9.06463 18.75C9.06463 19.0604 8.9505 19.3599 8.74424 19.5907C8.53797 19.8215 8.25416 19.9673 7.94747 20H2.23517C1.6107 19.9633 1.02579 19.6803 0.607331 19.2122C0.188872 18.7442 -0.0293796 18.129 -7.3727e-05 17.5V2.5C-0.0293796 1.87103 0.188872 1.2558 0.607331 0.787773C1.02579 0.319749 1.6107 0.0366881 2.23517 0H15.6467C16.2711 0.0366881 16.856 0.319749 17.2745 0.787773C17.693 1.2558 17.9112 1.87103 17.8819 2.5V8C17.8955 8.31422 17.786 8.62125 17.577 8.85503C17.368 9.08881 17.0761 9.23064 16.7643 9.25Z"
          fill={color || "#bbb"}
        />
        <path
          d="M11.9214 14H5.96073C5.69725 14 5.44456 13.8946 5.25826 13.7071C5.07195 13.5196 4.96729 13.2652 4.96729 13C4.96729 12.7348 5.07195 12.4804 5.25826 12.2929C5.44456 12.1054 5.69725 12 5.96073 12H11.9214C12.1849 12 12.4376 12.1054 12.6239 12.2929C12.8102 12.4804 12.9148 12.7348 12.9148 13C12.9148 13.2652 12.8102 13.5196 12.6239 13.7071C12.4376 13.8946 12.1849 14 11.9214 14Z"
          fill={color || "#bbb"}
        />
        <path
          d="M11.9214 10.3999H5.96073C5.69725 10.3999 5.44456 10.2945 5.25826 10.107C5.07195 9.91947 4.96729 9.66512 4.96729 9.3999C4.96729 9.13469 5.07195 8.88033 5.25826 8.6928C5.44456 8.50526 5.69725 8.3999 5.96073 8.3999H11.9214C12.1849 8.3999 12.4376 8.50526 12.6239 8.6928C12.8102 8.88033 12.9148 9.13469 12.9148 9.3999C12.9148 9.66512 12.8102 9.91947 12.6239 10.107C12.4376 10.2945 12.1849 10.3999 11.9214 10.3999Z"
          fill={color || "#bbb"}
        />
        <path
          d="M11.9214 6.80005H5.96073C5.69725 6.80005 5.44456 6.69469 5.25826 6.50716C5.07195 6.31962 4.96729 6.06527 4.96729 5.80005C4.96729 5.53483 5.07195 5.28048 5.25826 5.09294C5.44456 4.90541 5.69725 4.80005 5.96073 4.80005H11.9214C12.1849 4.80005 12.4376 4.90541 12.6239 5.09294C12.8102 5.28048 12.9148 5.53483 12.9148 5.80005C12.9148 6.06527 12.8102 6.31962 12.6239 6.50716C12.4376 6.69469 12.1849 6.80005 11.9214 6.80005Z"
          fill={color || "#bbb"}
        />
        <path
          d="M16.8984 11.8699L17.6038 11.1599C17.7899 10.9737 18.0417 10.8691 18.3041 10.8691C18.5666 10.8691 18.8184 10.9737 19.0045 11.1599L19.7099 11.8699C19.8949 12.0573 19.9988 12.3107 19.9988 12.5749C19.9988 12.8391 19.8949 13.0926 19.7099 13.2799L19.0045 13.9899L16.8984 11.8699ZM16.1931 12.5799L11.0669 17.7399C11.0216 17.7859 10.9859 17.8406 10.9621 17.9007C10.9382 17.9608 10.9265 18.0252 10.9278 18.0899V19.4999C10.9278 19.6325 10.9802 19.7597 11.0733 19.8535C11.1665 19.9473 11.2928 19.9999 11.4246 19.9999H12.8253C12.8905 20.0008 12.9551 19.9879 13.015 19.9621C13.0749 19.9362 13.1287 19.898 13.173 19.8499L18.2992 14.6899L16.1931 12.5799Z"
          fill={color || "#bbb"}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="20" height="20" fill={color || "#bbb"} />
        </clipPath>
      </defs>
    </svg>
  );
}
